module.exports = [
  "Thinking Big",
  "Calming Influence",
  "Confronting Conflicts",
  "Compassion and Care",
  "Learning Continuously",
  "Enthusiasm and Drive",
  "Flexibility",
  "Imagination",
  "Motivational Influence",
  "Negotiating Effectively",
  "Leadership",
  "Practical Solutions",
  "Trust and Responsibility",
  "Communication Skills",
  "Methodical Organization",
  "Networking Socially",
  "Decision Making",
  "Risk Taking",
];
